import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Constants } from "../../Common/Constants";
import { types } from "../../../Redux/Actions/types";
import TextField from "../../Common/Fields/TextField";
import ButtonCustom from "../../Common/Fields/ButtonCustom";
import {
  exercisePositionInsert,
  exercisePositionList,
  exercisePositionUpdate,
} from "../../../Redux/Actions";
import usePermissions from "../../Common/Functions/usePermissions";

const ExercisePositionForm = () => {
  const dispatch = useDispatch();
  const { exercisePositionSingle } = useSelector(
    (state) => state.ExercisePosition
  );
  // Initial values to exercise position form
  const [initialValues, setInitialValues] = useState({
    name: "",
  });
  // Permissions
  const addPermission = usePermissions(Constants.permission.BODY_PART_ADD);
  const editPermission = usePermissions(Constants.permission.BODY_PART_EDIT);

  // Validations for exercise position form
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(Constants.required),
  });

  useEffect(() => {
    // Set initial values to pre fill exercise position form
    if (exercisePositionSingle?._id) {
      const editValue = {};
      for (const [key] of Object.entries(initialValues)) {
        if (exercisePositionSingle[key]) {
          editValue[key] = exercisePositionSingle[key];
        }
        setInitialValues(editValue);
      }
    }
  }, [exercisePositionSingle]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        // Add or update exercise position API
        let submitFunc = exercisePositionInsert(values);
        if (exercisePositionSingle._id) {
          values.id = exercisePositionSingle._id;
          submitFunc = exercisePositionUpdate(values);
        }
        dispatch(submitFunc).then((response) => {
          if (response.error) {
            dispatch({
              type: types.ERROR_ALERT_VISIBLE,
              payload: response.error,
            });
          } else {
            dispatch({
              type: types.SUCCESS_ALERT_VISIBLE,
              payload: response.message,
            });
            dispatch({ type: types.EXERCISE_POSITION_SINGLE, payload: "" });
            dispatch({ type: types.EXERCISE_POSITION_FORM_MODEL, payload: "" });
          }
          dispatch(exercisePositionList());
        });
      }}
    >
      {({ errors, touched }) => (
        <Form className="row">
          <div className="col-md-12 mb-2">
            <TextField
              type="text"
              name="name"
              className="form-control"
              errors={touched?.name ? errors?.name : undefined}
              touched={touched?.name}
              label={Constants.name}
            />
          </div>
          {((addPermission && !exercisePositionSingle?._id) ||
            (editPermission && exercisePositionSingle?._id)) && (
            <ButtonCustom label={Constants.submit} type="submit" />
          )}
        </Form>
      )}
    </Formik>
  );
};

export default ExercisePositionForm;
